export default __webpack_public_path__ + "static/media/outbound_calls.492a6181.svg";